import React from 'react';

export default class Page2 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt task">
                                    <div className="innerpadding">


                                        <div className="ilead-contentarea">

                                            <div className="border_subtitle">This tool can help</div>
                                            <p>It is reasonable to think that if optimism can help Olympic
                                                athletes to achieve further success, it
                                                can also have an effect in projects and tasks in the workplace.
                                                This tool is all about <span className="brown brownbold">how to use
optimism to achieve</span> and outlines what optimism looks like and how taking a more positive
                                                approach can help you to realise your goals.</p>


                                            <div className="circle_title"><img
                                                src={require('@images/Browndot.png')}
                                                alt=""/>WHAT IS OPTIMISM?
                                            </div>
                                            <p>When we think about happiness and our general outlook on life, we
                                                are often categorised as
                                                being either optimistic or pessimistic. So what is optimism?</p>
                                            <div
                                                className="lightgreencontentbg keyquestionpad uiheading greennumberroundbg1">
                                                <p>Optimism is an outlook on life whereby an individual
                                                    maintains their view of the world as
                                                    being a positive place. The opposite of this would be
                                                    pessimism whereby the negative
                                                    aspects are focused upon.</p>
                                            </div>
                                            <p>People who are 'trait' optimists (that is, being optimistic is
                                                part of their personality rather than a
                                                matter of circumstance) are inclined to believe that people and
                                                events are inherently good and
                                                that, in the end, most situations work out for the best.
                                                Individuals with a more negative focus,
                                                however, can, while finding cause for their pessimism, overlook
                                                opportunities for optimism. In the
                                                last three decades, for example, 46,000 psychological papers
                                                have been published on depression
                                                and a mere 400 on joy!<a className="superscripttext"
                                                                         href="further_info.php?course=300"><sup>2</sup></a> Research
                                                has demonstrated that optimism is more than a 'nice to have'
                                                it has considerable and far reaching effects:</p>
                                            <div
                                                className="lightgreencontentbg keyquestionpad  greennumberroundbg1">
                                                <p> <span className="subtiltereg">Optimism is associated with stronger immune systems in healthy people, even when they
are subjected to stress.<a className="superscripttext" href="further_info.php?course=300"><sup>3</sup></a></span></p>
                                                <div className="uiheading"><p><span className="subtiltereg">Optimism is strongly related to self-esteem, psychological wellbeing and general health.<a
                                                    className="superscripttext"
                                                    href="further_info.php?course=300"><sup>4</sup></a></span>
                                                </p></div>
                                            </div>


                                            <p>Positive emotions such as happiness, joy and enthusiasm are also
                                                important for success in the
                                                workplace. When people are happy at work, their thinking tends
                                                to become more creative and
                                                they are more receptive to ideas or information. Employees with
                                                a positive outlook are also likely
                                                to direct more attention and effort towards their goals.<a
                                                    className="superscripttext"
                                                    href="further_info.php?course=300"><sup>5</sup></a></p>
                                            <p>For example, your company may have a new product being designed.
                                                Generating a positive,
                                                enthusiastic atmosphere spurs creativity and the will to
                                                succeed. Brainstorming can produce just
                                                such an optimistic environment, in which ideas and suggestions
                                                can be made freely.</p>
                                            <p>Optimism is important in maintaining a positive attitude in the
                                                workplace. Undue negativity can be
                                                an all too common response when something is perceived to have
                                                gone wrong. Someone who
                                                has just given a single, less-than-good presentation, for
                                                example, may start making negative
                                                generalisations about their ability to present at all!
                                                Unfortunately, by thinking or talking like that,
                                                they may be all the more nervous next time and likely to make
                                                more mistakes.<a className="superscripttext"
                                                                 href="further_info.php?course=300"><sup>6</sup></a>
                                            </p>

                                            <div
                                                className="lightgreencontentbg keyquestionpad  greennumberroundbg1 uiheading">
                                                <p>Solution-focused thinking is designed to combat the negative
                                                    trend of focusing purely on
                                                    problems instead of solutions. Problem-focused thinking
                                                    dwells on the problem itself –
                                                    how and why it happened, what it means and who or what is to
                                                    blame! Solution-focused
                                                    conversations, however, focus the mind on how one or another
                                                    solution could remedy a
                                                    situation. Solution-focused thinking also draws upon
                                                    previous experience of solving similar
                                                    problems. Using such insights, the solution-focused problem
                                                    solver would concentrate on
                                                    even the smallest steps which might lead them closer to
                                                    their goal. Even small successes
                                                    are noticeable, and can create a powerful momentum towards
                                                    change.<a className="superscripttext"
                                                              href="further_info.php?course=300"><sup>6</sup></a>
                                                </p>


                                                <div className="left-btn">
                                                    <div
                                                        onClick={this.props.handleChangePage('Page1')}
                                                        className="button-next-previous-done task">&lt;&lt; Previous
                                                    </div>
                                                </div>
                                                <div className="right-btn">
                                                    <div
                                                        onClick={this.props.handleChangePage('Page3')}
                                                        className="button-next-previous-done task">Next &gt;&gt;</div>
                                                </div>

                                            </div>

                                        </div>


                                    </div>


                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}